import { Routes } from '@angular/router';
import { isAuthenticatedGuard } from '@features/auth/guards/is-authenticated.guard';

export const AuthRoutes: Routes = [
    {
      path: 'auth',
      canActivate: [isAuthenticatedGuard],
      loadComponent: () => import('@features/auth/auth'),
      children: [
        { path: '', redirectTo: 'sign-in', pathMatch: 'full' },
        { path: 'sign-in', title: 'Iniciar sesión', loadComponent: () => import('@features/auth/views/sign-in/sign-in') },
        { path: 'forgot-password', title: 'Recuperar contraseña', loadComponent: () => import('@features/auth/views/forgot-password/forgot-password') },
        { path: 'reset-password', title: 'Restablecer contraseña', loadComponent: () => import('@features/auth/views/reset-password/reset-password') },
      ],
    },
    
  ];